import styled from 'styled-components';

import { gridSizes } from 'utils/style';
import CloseButton from 'components/ResponsiveModal/CloseButton/component';

export default styled(CloseButton)`
  margin-right: ${gridSizes('M')};
`;
